import React, {Component} from "react";
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import {withTranslate} from "react-redux-multilingual"
import OwlCarousel from "react-owl-carousel";
import IntroSlide from "./IntroSlide";
import {setHomeOutSliderSkeleton, setHomeSliderSkeleton} from "../../skeleton";

class Intro extends Component {
    constructor(props) {
        super(props);
        // Create the ref
        this.gradient = React.createRef();
        // this.device = React.createRef()

    }
  /*  componentWillMount() {
        this.handleLoading("none");
    }*/

    componentDidMount() {
        this.props.clearHomeIntro();
        this.props.getHomeSliders();
       /* if (document.readyState === 'complete') {
            this.handleLoading("block");
        }*/
        window.$(".owl-item").css({
            'height': "50px !important"
        });

    }

  /*  handleLoading = ( deviceDisplay) => {
        // const gradient = document.getElementById("gradient");
        const devices = document.getElementsByClassName("device");
    };*/

    render() {
        const {sliders,sliderIsLoading} = this.props;
        const slidersPage = sliders && sliders.length ? sliders.map((slide, index) => {
            return(
                <IntroSlide slide={slide} key={index}/>
            )
        }) : null;
        return (
              !sliderIsLoading
                 ?
                      sliders && sliders.length ?    <section className="intro">
                              <div className="container">
                                  <div className="row">
                                      <div className="col-md-12">
                                          {!sliderIsLoading ?  <OwlCarousel
                                              className="owl-theme"
                                              loop={true}
                                              slideBy={1}
                                              margin={40}
                                              dots={true}
                                              autoplay={true}
                                              lazyLoad={true}
                                              responsive={{
                                                  0: {
                                                      items: 1
                                                  },
                                                  600: {
                                                      items: 1
                                                  },
                                                  1000: {
                                                      items: 1
                                                  }
                                              }}>
                                              {slidersPage}
                                          </OwlCarousel> : setHomeSliderSkeleton() }

                                      </div>
                                  </div>
                              </div>
                          </section> : null

                : setHomeOutSliderSkeleton()

        )
    }
}

/*const mapStateToProps = (state) => {
    return {
        sliders: state.home.sliders,
        sliderIsLoading: state.home.sliderIsLoading,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getHomeSliders: () => dispatch(getHomeSliders()),
        clearHomeIntro: () => dispatch(clearHomeIntro())
    }
};*/

export default (withTranslate(Intro))
